import { getDefaultApi } from './ChinookApiService';

export const rafraichirToken = () =>
         getDefaultApi()
           .rafraichirToken()
           .then((response) => response.data);


export const getJwtContributeur = () =>
  getDefaultApi()
    .connecterSSO()
    .then((response) => response.data);
